import UserStructureWithProfiles from "../../Constants/UserStructureWithProfile"; // adjust path

export const FetchUserData = async (userid) => {
  try {
    const response = await fetch(`/api/mock/UserProfile/UserMockData-${userid}.json`);
    const data = await response.json();
    const formattedData = {
      ...UserStructureWithProfiles,
      userId: data.userId || "",
      name: {
        firstName: data.name?.firstName || "",
        lastName: data.name?.lastName || ""
      },
      imageUrl: data.imageUrl || "",
      gender: data.gender || "",
      ethenic: data.ethenic || "",
      email: data.email || "",
      password: data.password || "",
      mobileNumber: data.mobileNumber || "",
      devices: data.devices || [],
      dateOfBirth: data.dateOfBirth || "",
      address: {
        street: data.address?.street || "",
        city: data.address?.city || "",
        state: data.address?.state || "",
        zipCode: data.address?.zipCode || "",
        country: data.address?.country || ""
      },
      consent: {
        termsAccepted: data.consent?.termsAccepted || false,
        emailMarketing: data.consent?.emailMarketing || false,
        analyticsTracking: data.consent?.analyticsTracking || false
      },
      payAccounts: {
        paypal: data.payAccounts?.paypal || "",
        stripe: data.payAccounts?.stripe || ""
      },
      nProfCount: data.nProfCount || 0,
      profiles: Array.isArray(data.profiles)
        ? data.profiles.map((profile) => ({
            profileName: profile.profileName || "",
            profileId: profile.profileId || "",
            profileUUID: profile.profileUUID || "",
            profileImage: profile.profileImage || "",
            profileTheme: profile.profileTheme || ""
          }))
        : []
    };

    return formattedData;
  } catch (error) {
    console.error("Failed to fetch user with profiles data:", error);
    return null;
  }
};
